import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Input,
    ViewChild,
    Output,
    EventEmitter,
    ChangeDetectorRef,
} from '@angular/core';
import { Folder } from 'src/app/acl-data/folder/folder.dto';
import { environment } from 'src/environments/environment';
import { FileUploader } from 'ng2-file-upload';
import { ParallelHasher } from 'ts-md5/dist/parallel_hasher';
import { BehaviorSubject, Observable } from 'rxjs';

export interface IFileData {
    name: string;
    size: number;
    hash: string;
    isPDF: boolean;
    fileObject: any;
}

@Component({
    selector: 'app-document-upload-select',
    templateUrl: './document-upload-select.component.html',
    styleUrls: ['./document-upload-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentUploadSelectComponent implements OnInit {
    @Input() folder: Folder;

    @ViewChild('preview', { static: false }) preview;
    @ViewChild('fileSelector', { static: true }) fileSelector;

    public uploader: FileUploader = new FileUploader({
        url: environment.contractFormURL,
    });
    fileWarnSize = environment.fileWarnSize;
    pdfData;
    file$: BehaviorSubject<IFileData> = new BehaviorSubject(null);

    get file(): Observable<IFileData> {
        return this.file$.asObservable();
    }

    displaySize = (input: number) =>
        Math.round((input / 1024 / 1024) * 100) / 100;

    constructor() {}

    ngOnInit() {
        this.uploader.onAfterAddingFile = (fileItem: any) => {
            const isPDFValue = fileItem.file.name
                .toLowerCase()
                .endsWith('.pdf');
            const filename = fileItem.file.name;
            const sizeValue = fileItem.file.size;
            const file = this.fileSelector.nativeElement.files[0];
            // const uploader = this.uploader;

            const reader = new FileReader();
            reader.onloadend = (e: any) => {
                this.pdfData = e.target.result;

                const hasher = new ParallelHasher('assets/md5_worker.js');
                // tslint:disable-next-line: no-string-literal
                hasher['parent'] = this;

                const blob = new Blob([reader.result]);
                hasher.hash(blob).then(result => {
                    console.log('Hash OK');
                    // contractFormService.setFileData({
                    //     // uploader: uploader,
                    this.file$.next({
                        name: filename,
                        size: sizeValue,
                        hash: result,
                        isPDF: isPDFValue,
                        fileObject: file,
                    });
                });
            };
            reader.readAsArrayBuffer(file);
        };
    }
}
